import { useContext } from 'react';
import { ChallengePlayerContext } from './challenge-player-context/challenge-player-context';
import { getCurrentActivity } from './challenge-player-context/get-current-activity';
export var useChallengePlayer = function useChallengePlayer() {
  var _useContext = useContext(ChallengePlayerContext),
      manuallyOpenChallengePlayer = _useContext.manuallyOpenChallengePlayer,
      challengePlayerState = _useContext.challengePlayerState,
      closeChallengePlayer = _useContext.closeChallengePlayer,
      advanceStage = _useContext.advanceStage;

  return {
    manuallyOpenChallengePlayer: manuallyOpenChallengePlayer,
    challengePlayerState: challengePlayerState,
    closeChallengePlayer: closeChallengePlayer,
    advanceStage: advanceStage,
    getCurrentActivity: getCurrentActivity
  };
};